import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-select-icon',
  templateUrl: './design-select.component.html'
})
export class DesignSelectComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
